import { Helmet } from "react-helmet-async";

const SITE = "Numoraa";
const BASE = "https://numora.fun";

export default function SEO({
  title,
  description,
  path = "",
  image,
  type = "website",
  schema,
  noindex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — India's AI-Powered Numerology Platform`;
  const desc = description || "Discover your life numbers with Numoraa — AI-powered numerology tools, palm reading, Lo Shu grid, personalized reports and live AI Pandit consultations.";
  const url = `${BASE}${path}`;
  const img = image || `${BASE}/og-image.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={SITE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}

export const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Numoraa",
  url: BASE,
  description: "India's AI-powered numerology platform.",
  sameAs: [],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Numoraa",
  url: BASE,
};

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${BASE}${it.path}`,
    })),
  };
}

export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };
}
